import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import ATextarea from '../../../common/formFeilds/customInput/ATextarea';
import { ReactComponent as CloseIcon } from "assets/img/svg/closeSquare.svg";
import AButton from '../../../common/form-fields-mui/AButton';
import { regex } from '../../../common/constant';

const AddApplicationListPopup = ({
    dialogInfo,
    setDialogInfo,
    rowFormHandler
}) => {

    const { isOpen, viewOnly, initialApplicationList = "" } = dialogInfo;

    const [inputVal, setInputVal] = useState(initialApplicationList);

    const closeDialog = () => setDialogInfo({});

    const updateApplicationLists = () => {
        const applicationListArr = inputVal.split(',').filter(val => Boolean(val));
        rowFormHandler(applicationListArr, "applicationList");
        closeDialog();
    }

    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="sm"
        >
            <div className='p-3'>

                <div className='d-flex justify-content-between'>
                    <h3>Application List</h3>
                    <CloseIcon className='cursor' onClick={closeDialog} />
                </div>

                <ATextarea
                    placeholder='Enter Applications'
                    onChange={val => setInputVal(val)}
                    disabled={viewOnly}
                    value={inputVal}
                    maxlength = {110}
                    regex={/^(\d+)(,(\d*)?){0,9}?$|^$/} //regex that allows maximum 10 comma separated numbers
                />

                {!viewOnly && <AButton
                    variant='primary_filled'
                    className='no-ml-btn d-block'
                    onClick={updateApplicationLists}
                    disabled={!inputVal}
                >
                    Save
                </AButton>
                }

            </div>

        </Dialog>
    );
}

export default AddApplicationListPopup;